import dynamic from "next/dynamic";
import { Suspense } from "react";
import Head from "next/head";
import { GetServerSideProps, NextPage } from "next";
import { useRouter } from "next/router";
import CategoryController from "../../controller/category.controller";

const Bar = dynamic(import("../../components/Blog/Bar"), { suspense: true });
const Card = dynamic(import("../../components/Blog/Card"), { suspense: true });
const Pagination = dynamic(import("rc-pagination"), { suspense: true });

export interface IBlogsProps {
  blog: any;
  categoryDetail: any;
  categories: any;
}

const CategoryPage: NextPage<IBlogsProps> = ({
  blog,
  categories,
  categoryDetail,
}) => {
  const router = useRouter();
  const category: string = router.query.category as string;

  return (
    <>
      <Head>
        <title>
          {categoryDetail.length !== 0
            ? `${categoryDetail[0].metaTitle}`
            : `${category} - BungalowFinder`}
        </title>
        <meta
          name="title"
          property="og:title"
          content={
            categoryDetail.length !== 0
              ? `${categoryDetail[0].metaTitle}`
              : `${category} - BungalowFinder`
          }
        />
        <meta
          name="description"
          property="og:description"
          content={
            categoryDetail.length !== 0
              ? `${categoryDetail[0].metaDesc}`
              : `Read out blogs about ${category} on BungalowFinder`
          }
        />
        <meta
          name="keywords"
          content={
            categoryDetail.length !== 0 ? `${categoryDetail[0].metaDesc}` : ``
          }
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content={"https://bungalowfinder.ca" + router.asPath}
        />
        <meta
          property="og:image"
          content="https://bungalowfinder.ca/bungalow-color-logo.png"
        />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta
          property="og:image:alt"
          content="Latest Trends of Ontario Real Estate market on Bungalow Finder"
        />
      </Head>
      <>
        <div className="bg-gray-500">
          <Suspense fallback={<>Loading ...</>}>
            <div className="container mx-auto">
              <Bar categories={categories} />
            </div>
          </Suspense>
        </div>

        <div className="bg-gray-100">
          <div className="container mx-auto py-3 text-center md:text-left">
            <h1 className="text-xl font-normal">
              {category.replaceAll("-", " ")}
            </h1>
          </div>
          <hr />
          <section className="container mx-auto py-5 ">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              <Suspense
                fallback={
                  <>
                    <p>Loading...</p>
                  </>
                }
              >
                {blog.data.length != 0 ? (
                  blog.data.map((item: any) => (
                    <Card key={item.slug} item={item} />
                  ))
                ) : (
                  <></>
                )}
              </Suspense>
            </div>
          </section>
          <div className="text-center w-full pb-5">
            <Suspense
              fallback={
                <>
                  <p>Loading...</p>
                </>
              }
            >
              <Pagination
                pageSize={6}
                total={blog.total}
                onChange={(e) => {
                  router.push({
                    pathname: `/category/${router.query.category}`,
                    query: { page: e },
                  });
                }}
              />
            </Suspense>
          </div>
        </div>
      </>
    </>
  );
};

export default CategoryPage;
export const getServerSideProps: GetServerSideProps = async (context) => {
  return await CategoryController(context);
};
